<template>
  <BaseLineClamp
    :lines="6"
    :show-all="showAll"
  >
    <slot />
    <template #after="{ clamped }">
      <BaseButton
        v-if="clamped"
        :aria-expanded="showAll"
        class="outreach-contact-profile-content__expand"
        :label="
          getLocaleText(
            `${
              showAll
                ? 'outreach_contact_profile_section.show_less'
                : 'outreach_contact_profile_section.show_more'
            }`
          )
        "
        new-design
        @click="showAll = !showAll"
      >
        <template #after>
          <QIcon
            :name="showAll ? 'expand_less' : 'expand_more'"
            size="xs"
          />
        </template>
      </BaseButton>
    </template>
  </BaseLineClamp>
</template>

<script setup lang="ts">
import { getLocaleText } from "shared/boot/i18n";
import { BaseButton, BaseLineClamp } from "shared/components/base";

const showAll = defineModel<boolean>({
  default: false,
});
</script>

<style lang="scss" scoped>
.outreach-contact-profile-content {
  &__expand {
    margin-top: 4px;

    --c-button-padding-inline: 0px;
    --c-button-bg-hover: transparent;
    --c-button-border-hover: transparent;
    --c-button-color: var(--s-color-blue-9);
    --c-button-color-hover: var(--s-color-blue-5);
  }
}
</style>
